











































import {
    Prop,
    Component,
    Mixins,
    ProvideReactive,
    Provide,
} from "vue-property-decorator";
import CalendarMixin from "./CalendarMIxin";
import {
    Day,
    calendarRows,
    MONTH_NAMES,
    shortDayNames,
} from "../../date-picker/private/Utils";
import AButton from "../../date-picker/private/AButton.vue";

@Component({
    inject: [],
    components: {
        AButton,
    },
})
export default class CalendarYearView extends Mixins(CalendarMixin) {
    @Prop({ type: Boolean }) isMondayFirst!: boolean;

    @Provide("setCurDate") setCurDate(dt: Date) {
        this.curDate = dt;
    }
    @Provide("isMondayFirst") mondayFirst = this.isMondayFirst;

    private get dayHeaders(): string[] {
        return shortDayNames(this.isMondayFirst);
        //return ['lun', 'mar', 'mer', 'gio', 'ven', 'sab', 'dom'];
    }

    private get months(): (Day | string)[][][] {
        const months = [];
        for (let i = 0; i < 12; i++) {
            let rows: (Day | string)[][];
            rows = calendarRows(
                new Date(this.refDate.getFullYear(), i, 1),
                new Date(this.refDate.getFullYear(), i, 1),
                this.isMondayFirst
            );
            rows = [...[this.dayHeaders], ...rows];
            months.push(rows);
        }
        this.$emit("new-range", [
            new Date(this.refDate.getFullYear(), 0, 1),
            new Date(this.refDate.getFullYear(), 11, 31, 23, 59, 59, 999),
        ]);
        return months;
    }

    private monthNames(index: number) {
        return MONTH_NAMES[index];
    }

    private dayClass(day: Day) {
        return {
            "text-gray-500": day.out,
            "current": day.today,
        };
    }
}
